import { render } from "./document-breadcrumbs.vue?vue&type=template&id=ba53f8df"
import script from "./document-breadcrumbs.vue?vue&type=script&lang=js"
export * from "./document-breadcrumbs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__